export default __webpack_public_path__ + "static/media/word.565c1ff8.svg";